module.exports = __webpack_public_path__ + "static/media/success.ceaaf435.svg";